import React from 'react'
import {
  SpacerVertical,
  Stepper
} from '@klarna/bubble-ui'

import content from './content'
import { interpolateContent } from './utils'

export interface TimelineCopy {
  [key: string]: string
}

interface LearnMoreTimelineProps {
  copy?: TimelineCopy
  bespokeId?: string
  spacer?: boolean
}

function getContentOverrideWhenApplicable(bespokeId?: string) {
  switch (bespokeId) {
    case 'logo':
      return { badge: content.logo }
    default:
      return content
  }
}

function LearnMoreTimeline({ copy, bespokeId, spacer = true }: LearnMoreTimelineProps) {
  if (!copy) return null

  const entries = Object.keys(copy).map((index: string) => ({
    title: interpolateContent(copy[index], getContentOverrideWhenApplicable(bespokeId))
  }))

  return (
    <div className="timeline">
      { spacer ? <SpacerVertical spaceToken='space/100'/> : '' }
      <Stepper>
        {entries.map((entry, index) => (
          // @ts-ignore
          <Stepper.Item key={index} title={entry.title} />
        ))}
      </Stepper>
    </div>
  )
}

export default LearnMoreTimeline
